'use strict';

var _ = require('lodash');
var InformationTooltipFactory = function InformationTooltipFactory() {
  var HIDE_DELAY = 50;
  function InformationTooltip() {}
  InformationTooltip.constructor = InformationTooltip;
  function getHtmlContent(cellData, wholeGridData) {
    var tooltipData = {
      description: wholeGridData[cellData.row].description,
      information: cellData.value
    };
    var tooltipContent = _.template(require('../templates/information-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  InformationTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      if (cellData.value) {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData),
          hideDelay: HIDE_DELAY,
          noOffset: true,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return InformationTooltip;
};
module.exports = InformationTooltipFactory;